import React from "react";
import { InstantSearch } from "react-instantsearch/dom";
import {
  connectRefinementList,
  connectRange,
  connectAutoComplete
} from "react-instantsearch/connectors";

const refinementAttributes = [
  { label: "Kollektionen", refinement: "brand" },
  { label: "Segment", refinement: "segment.valueDE" },
  { label: "Material", refinement: "material.categoryDE" },
  { label: "Fassungsart", refinement: "frameType.valueDE" },
  { label: "Fassungstyp", refinement: "shapeForm.valueDE" },
  { label: "Farbe", refinement: "color.categoryDE" }
];

const rangeAttributes = [
  { label: "Preis", refinement: "price" },
  { label: "Stegweite", refinement: "bridgeWidth" },
  { label: "Scheibengröße", refinement: "lensWidth" }
];

const VirtualRefinementList = connectRefinementList(() => null);
const VirtualRange = connectRange(() => null);
const VirtualAutoComplete = connectAutoComplete(() => null);

export default class AlgoliaWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchState: {}
    };
  }

  onSearchStateChange = nextSearchState => {
    const { searchState } = this.state;
    this.setState({
      searchState: { ...searchState, ...nextSearchState }
    });
  };

  onResetSearchState = () => {
    this.setState({
      searchState: {}
    });
  };

  clearAutoComplete = () => {
    const { searchState } = this.state;
    this.setState({
      searchState: { ...searchState, query: "" }
    });
  };

  getDefaultRefinement = attribute => {
    const { searchState } = this.state;
    let attributeSearchState;
    if (searchState.refinementList) {
      attributeSearchState = Array.isArray(
        searchState.refinementList[attribute]
      )
        ? searchState.refinementList[attribute]
        : [];
    }
    return attributeSearchState;
  };

  getDefaultRange = attribute => {
    const { searchState } = this.state;
    let attributeSearchState;
    if (searchState.range) {
      attributeSearchState =
        searchState.range[attribute] !== undefined
          ? searchState.range[attribute]
          : { min: undefined, max: undefined };
    }
    return attributeSearchState;
  };

  getDefaultRefinements = attributes =>
    attributes.reduce((acc, val) => {
      acc[val] = this.getDefaultRefinement(val);
      return acc;
    }, {});

  getDefaultRanges = attributes =>
    attributes.reduce((acc, val) => {
      acc[val] = this.getDefaultRange(val);
      return acc;
    }, {});

  render() {
    const { searchState } = this.state;
    const { appID, apiKey, indexName, render } = this.props;
    const defaultRefinements = {
      ...this.getDefaultRefinements(
        refinementAttributes.map(r => r.refinement)
      ),
      ...this.getDefaultRanges(rangeAttributes.map(r => r.refinement))
    };
    return (
      <InstantSearch
        appId={appID}
        apiKey={apiKey}
        indexName={indexName}
        root={{ Root: "div", props: { className: "w-full h-full" } }}
        onSearchStateChange={this.onSearchStateChange}
        searchState={searchState}
      >
        <VirtualAutoComplete />
        <VirtualRange
          attribute="price"
          defaultRefinement={{ ...defaultRefinements.price }}
        />
        <VirtualRange
          attribute="lensWidth"
          defaultRefinement={{ ...defaultRefinements.lensWidth }}
        />
        <VirtualRange
          attribute="bridgeWidth"
          defaultRefinement={{ ...defaultRefinements.bridgeWidth }}
        />

        {refinementAttributes.map((attribute, key) => {
          const { refinement } = attribute;
          return (
            <VirtualRefinementList
              key={key}
              attribute={refinement}
              defaultRefinement={defaultRefinements[refinement]}
            />
          );
        })}
        {render({
          searchState,
          onResetSearchState: this.onResetSearchState,
          clearAutoComplete: this.clearAutoComplete,
          defaultRefinements,
          refinementAttributes
        })}
      </InstantSearch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/AlgoliaWrapper/AlgoliaWrapper.js